import { render, staticRenderFns } from "./IrisSearchfield.vue?vue&type=template&id=624096d8&"
import script from "./IrisSearchfield.vue?vue&type=script&lang=ts&"
export * from "./IrisSearchfield.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSearchfield.vue?vue&type=style&index=0&id=624096d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports